import _ from 'underscore';
import { useEffect, useState, useRef } from 'react';
import { fetchAggregatedData } from '@bingads-webui-campaign/overview-cards-common';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import { cardDeviceId } from '@bingads-webui-campaign/fluent-page-consts';

export const useHasTooManyAccounts = ({
  navigationLevel,
  dateRange,
  getCardsConfig,
  permissions,
  tiles,
  overviewPageActivity,
}) => {
  const [showTooMuchDataError, setShowTooMuchDataError] = useState(false);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    let cancel = false;

    if (navigationLevel === 'customer' && !hasFetchedRef.current) {
      hasFetchedRef.current = true;

      const result = fetchAggregatedData({
        entitySet: edm.currentCustomer.Accounts,
        dateRange,
        jsdata,
        dateUtil,
        getCardsConfig,
        permissions,
        dfmCacheKey: cardDeviceId,
      });

      if (result && typeof result.then === 'function') {
        result
          .then((response) => {
            if (cancel) return;
            if (
              Array.isArray(response.errors) &&
              _.some(response.errors, error => error.Code === 'TooMuchDataToDownload')
            ) {
              setShowTooMuchDataError(true);
            }
          })
          .catch((error) => {
            if (cancel) return;
            overviewPageActivity.trace('Error in fetchMCCOverview:', error);
          });
      } else {
        console.error('fetchAggregatedData did not return a Promise:', result);
      }
    }

    return () => {
      cancel = true;
    };
  }, [navigationLevel, dateRange, getCardsConfig, permissions, tiles, overviewPageActivity]);

  return showTooMuchDataError;
};
